import cx from 'classnames';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';

import { Image } from '../../index';
import * as styles from './Breaker.module.css';

const Breaker = ({
	children,
	image,
	alt,
	as: Component = 'div',
	className = '',
}: {
	children?: React.ReactNode;
	image: IGatsbyImageData;
	alt: string;
	as?: React.ElementType;
	className?: string;
}) => {
	return (
		<Component className={cx(styles.breaker, className)}>
			{image && (
				<div className={styles.image}>
					<Image image={image} alt={alt} />
				</div>
			)}
			{children && <div className={styles.box}>{children}</div>}
		</Component>
	);
};

export default Breaker;
